<template>
  <v-layout row wrap class="mt-3">
    <v-flex
      xs12
      sm12
      md2
      class="font-weight-bold orange--text"
    >{{ $t(`avails.film.overview.label.${media_type}`) }}</v-flex>
    <v-flex xs12 sm12 md10 v-if="medias">
      <v-layout row wrap v-if="medias.length">
        <v-flex xs3 v-for="(item,index) in medias" :key="index" pa-1>
          <v-card height="100px" hover class="text">
            <div class="media_file_container" v-if="item">
              <div
                @click="
                selected_item = item,
                item.file_mimetype.includes('video') ?  previewMedia(item) : null"
                :style="{
                            background: 'url('+item.thumb+')' ,
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            bottom: '0',
                            right: '0',
                            backgroundPosition: '50%',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'contain'
                      }"
              ></div>
            </div>
          </v-card>
        </v-flex>
        <v-dialog v-if="videoUrl" :value="showPreview" persistent width="800px">
          <v-card>
            <v-card-title primary-title>
              <v-layout row wrap>
                <v-flex
                  xs10
                  sm10
                  md10
                  lg10
                  class="text-truncate headline"
                >{{selected_item.file_name}}</v-flex>
                <v-flex xs2 sm2 md2 lg2 class="text-xs-right">
                  <v-btn
                    small
                    dark
                    icon
                    color="red"
                    :style="{marginTop: '-8px'}"
                    @click="showPreview = false , videoUrl = null "
                  >
                    <v-icon small>$vuetify.icons.rms_close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-1">
              <embed-player v-bind:value="videoUrl" :video_type="this.video_type"></embed-player>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import EmbedPlayer from "@/components/film/EmbedPlayer.vue";
export default {
  name: "Medias",
  components: {
    EmbedPlayer
  },
  data() {
    return {
      showPreview: false,
      videoUrl: null,
      video_type: null,
      selected_item: null
    };
  },
  props: ["media_type", "file_type", "film_id"],
  computed: {
    medias: function() {
      return this.$store.getters["film/getMediasFromId"](
        this.media_type,
        this.film_id
      );
    }
  },
  methods: {
    previewMedia(media) {
      this.showPreview = true;
      this.videoUrl = media.video_url;
      this.video_type = media.mime_type;
    }
  }
};
</script>

<style>
</style>
